import angular from 'angular';
import uiRouter from 'angular-ui-router';
import listaMerchantSuperAdmin from './listaMerchantSuperAdmin.component';

const loginSuperAdminModule = angular.module('tinaba.components.listaMerchantSuperAdmin', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';

  $stateProvider.state('listaMerchantSuperAdmin', {
    url: '/superAdmin',
    template: '<lista-merchant-super-admin></lista-merchant-super-admin>'
  });
})

.component('listaMerchantSuperAdmin', listaMerchantSuperAdmin);

export default loginSuperAdminModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/listaMerchantSuperAdmin/listaMerchantSuperAdmin.js
 **/